<template>
  <div class="content">
    <div class="iconWrapper">
      <i class="icon bi bi-exclamation" />
    </div>
    <div class="title">Vous devez relancer votre session</div>
    <div class="subtitle"><slot name="text"></slot></div>
    <Button class="primary" label="Relancer la session" @click="$emit('back')" />
  </div>
</template>

<style lang="scss" scoped>
.content {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;

  .iconWrapper {
    width: 64px;
    height: 64px;

    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    font-size: 48px;

    background-color: #F40000;
  }

  .title {
    font-size: 32px;
    font-weight: 700;

    margin: 8px 0;
  }

  .subtitle {
    font-size: 18px;
    text-align: center;

    :deep(b) {
      font-weight: 700;
      color: #F2CB36;
    }
  }

  .btn {
    margin-top: 40px;
  }

}
</style>

<script setup lang="ts">
</script>